import WaydFrequencyChart from "./WaydFrequencyChart";

export default WaydFrequencyChart;
